import { useIsCurrentUserAdminLogin } from '@psl/functions/auth/utils';
import { showAlert } from '@psl/functions/ux/showAlert';
import { memo, useEffect } from 'react';

export const AdminLoginAlert = memo(() => {
  const isAdminLogin = useIsCurrentUserAdminLogin();
  useEffect(() => {
    if (isAdminLogin) {
      void showAlert(
        'Remind',
        "You're currently logged in as admin and acting on behalf of this user!",
      );
    }
  }, [isAdminLogin]);
  return null;
});
